import {
  useHotelOfferPages,
  type HotelOfferPages,
  type HotelOfferPagesQuery,
} from '@voll-intelligence/intelligence-ui-kit';

import {
  type HotelPlannerPort,
  HOTEL_RESULTS_PAGE_MAX,
  HOTEL_SEARCH_STALE,
  type ChatUiHotelOffer,
  type HotelResultsCuts,
} from '@voll-intelligence/genui-contract';

export type HotelResultsQuery = HotelOfferPagesQuery<HotelResultsCuts>;

/**
 * As páginas da lista completa do painel, lidas pela porta do planner. A regra
 * (página 1 que supera, coordenação por chave, busca vencida) mora no kit
 * (`useHotelOfferPages`); aqui entram a porta, o teto da página e o nome do
 * erro de busca vencida, que são contrato do wire.
 */
export function useHotelResultsPage(input: {
  port: HotelPlannerPort | undefined;
  sessionId: string | undefined;
  /** O painel está aberto? Fechado não busca — a página é leitura efêmera. */
  enabled: boolean;
  query: HotelResultsQuery;
  /** Muda a cada busca nova (ver `useHotelOfferPages`). */
  resetToken?: string;
}): HotelOfferPages<ChatUiHotelOffer> {
  const { port, ...rest } = input;
  return useHotelOfferPages({
    ...rest,
    fetchPage: port?.searchHotelPage,
    pageLimit: HOTEL_RESULTS_PAGE_MAX,
    staleErrorName: HOTEL_SEARCH_STALE,
  });
}
